import { connect } from 'react-redux';
import { ManageEquipmentSelect as ManageEquipmentSelectComponent } from './manage-equipment-select.component';
import { AppState } from '../../app.state';

export const ManageEquipmentSelect = connect((sState: AppState) => ({
  sState,
  //@ts-ignore
}))(ManageEquipmentSelectComponent as any) as unknown as typeof ManageEquipmentSelectComponent;
